import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../providers/api.service';
import { SM_CONSTANTS } from '../../shared/constants/sm-constants';
import { MatDialog } from '@angular/material/dialog';
import { AddNewBookingComponent } from 'src/app/shared/components/add-new-booking/add-new-booking.component';
import { ManageBookingComponent } from 'src/app/shared/components/manage-booking/manage-booking.component';
import { AssignJobComponent } from 'src/app/shared/components/assign-job/assign-job.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { CustomiseBookingComponent } from 'src/app/shared/components/customise-booking/customise-booking.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { AddEditTaxGstComponent } from 'src/app/shared/components/add-edit-tax-gst/add-edit-tax-gst.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ChangeNumberComponent } from 'src/app/shared/components/change-number/change-number.component';

@Component({
  selector: 'sm-phone-number-change',
  templateUrl: './phone-number-change.component.html',
  styleUrls: ['./phone-number-change.component.scss']
})
export class PhoneNumberChangeComponent implements OnInit, OnDestroy {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  taxData: any = []
  toShowCheck: number = 1
  private _apiSubscription: Subscription;
  loader: boolean = false
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, public _modelRef: MatDialog,  private loaderService: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{

      // if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_DATA){
      //   this.taxData = []
      //   if(resData.result){
      //     resData.result.forEach((element:any) => {
      //       this.taxData.push(element)
      //       this.toShowCheck = this.taxData[0].taxCollectionStatus
      //     });
      //   }
      //   else{
      //     this.toShowCheck = 0
      //   }
      //   this.loaderService.showLoader = false
      //   this.loader = false
      // }
      // if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_TAX_DATA){
      //   if(resData.result){
      //     this._apiService.getEntityTaxData(this.entityHashId)
      //   }
      // }

    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
   }

  ngOnInit(): void {
   
   
    // this.loaderService.showLoader = true
    // this.loader = true
    // this._apiService.getEntityTaxData(this.entityHashId)



  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
  
  onToggleChange(event: any) {
    if(event.checked){
      this.toShowCheck = 1
      let data = {
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        businessHashId: this.entityHashId,
        tax_collection_status: 1
      }
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.addEditEntityTaxData(data)
    }
    else if (!event.checked){
      this.toShowCheck = 0
      let data = {
        createdBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        editedBy: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        businessHashId: this.entityHashId,
        tax_collection_status: 0
      }
      this.loaderService.showLoader = true
      // this.loader = true
      this._apiService.addEditEntityTaxData(data)
    }
  }

  changeNumber(){
    this._modelRef.open(ChangeNumberComponent, {
      width: '500px',
      data: {
        title: 'Change Phone Number',
        ref: this._modelRef,
      },
    });
  }


  isOpen = false;

  toggle() {
    this.isOpen = !this.isOpen;
  }


}


